import React from 'react';

import { productService } from '../../services';
import { CategoryProps } from './category-type';
import { EnhancedQuerystringFilterableProductList } from '../../enhanced-components';

import enhancer from './category-enhancer';

export const categoryPage: React.FC<CategoryProps> = React.memo(({ category }: CategoryProps) => {
    if (!category) {
        return <React.Fragment />;
    }

    return (
        <EnhancedQuerystringFilterableProductList
            id={`${category.id}`}
            fetchProducts={productService.searchByCategory}
            categoryData={category}
        />
    );
});

export const CategoryPage = enhancer(categoryPage);
